import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Skull } from "lucide-react";
import { TESTIMONIALS } from "@/lib/data";

export default function Testimonial() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % TESTIMONIALS.length), 5200);
    return () => clearInterval(t);
  }, []);

  const q = TESTIMONIALS[idx];

  return (
    <section id="fans" className="relative py-28 sm:py-36 newsprint-grain overflow-hidden">
      <div className="absolute inset-0 halftone opacity-[0.07] pointer-events-none" />
      <div className="absolute inset-0 blood-vignette pointer-events-none" />
      <div className="relative mx-auto max-w-4xl px-4 sm:px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex justify-center gap-1.5 mb-8"
        >
          {[...Array(5)].map((_, i) => (
            <Skull key={i} size={22} className="text-crimson fill-crimson crimson-glow" />
          ))}
        </motion.div>
        <AnimatePresence mode="wait">
          <motion.blockquote
            key={idx}
            data-testid="testimonial-quote"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -24 }}
            transition={{ duration: 0.5 }}
          >
            <p className="font-type text-xl sm:text-2xl lg:text-3xl text-paper leading-relaxed mb-8">
              "{q.quote}"
            </p>
            <footer>
              <p className="font-marker text-bloodglow text-lg rotate-[-1deg] inline-block">{q.author}</p>
              <p className="font-courier text-xs uppercase tracking-widest text-paper/50 mt-1">{q.role}</p>
            </footer>
          </motion.blockquote>
        </AnimatePresence>
        <div className="flex justify-center gap-2 mt-10">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              data-testid={`testimonial-dot-${i}`}
              onClick={() => setIdx(i)}
              aria-label={`Show testimonial ${i + 1}`}
              className={`w-2.5 h-2.5 border border-crimson transition-colors duration-200 ${i === idx ? "bg-crimson" : "bg-transparent"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
